var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfissionais(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14209 4.67786C9.71966 4.67786 11.5901 6.81854 11.5903 9.22083C11.5903 11.5791 9.7204 13.7648 7.14209 13.7648C4.5188 13.7646 2.64893 11.5797 2.64893 9.22083C2.64912 6.81789 4.51955 4.67798 7.14209 4.67786ZM7.14209 5.96692C5.28283 5.96704 3.99287 7.52577 3.99268 9.22083C3.99268 10.8716 5.2819 12.4316 7.14209 12.4318C8.95572 12.4318 10.2466 10.8726 10.2466 9.22083C10.2464 7.52472 8.9548 5.96692 7.14209 5.96692Z",
    fill: "#444242",
    stroke: "#444242",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9834 14.7306C11.4092 14.7306 13.3388 16.7326 13.3389 19.1417V20.1749H12.042V19.1417C12.0419 17.4631 10.6824 16.0861 8.9834 16.0861H5.25488C3.59885 16.0861 2.19635 17.464 2.19629 19.1417V20.1749H0.900391V19.1417C0.900446 16.732 2.8736 14.7306 5.25488 14.7306H8.9834Z",
    fill: "#444242",
    stroke: "#444242",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1494 4.96875C19.526 4.96875 21.2058 7.03559 21.2061 9.31543C21.2061 11.5515 19.5256 13.6191 17.1494 13.6191C14.8172 13.6189 13.1387 11.5505 13.1387 9.31543C13.1389 7.03652 14.8168 4.96901 17.1494 4.96875ZM17.1494 6.28613C15.5749 6.28641 14.4494 7.74563 14.4492 9.31543C14.4492 10.8397 15.574 12.3005 17.1494 12.3008C18.7705 12.3008 19.8945 10.8388 19.8945 9.31543C19.8943 7.7466 18.7695 6.28613 17.1494 6.28613Z",
    fill: "#444242",
    stroke: "#444242",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9292 14.1479C21.2152 14.1479 23.1001 15.8977 23.1001 18.0972V19.0103H21.7368V18.0972C21.7368 16.6167 20.4885 15.4165 18.9292 15.4165H15.4849C15.0743 15.4166 14.7667 15.4949 14.4927 15.6421C14.2161 15.7907 13.9683 16.0133 13.6792 16.311L13.6099 16.3823L13.5376 16.313L12.7319 15.5415L12.6626 15.4751L12.7261 15.4028C13.1119 14.9688 13.4918 14.6529 13.9331 14.4468C14.3746 14.2406 14.8708 14.148 15.4849 14.1479H18.9292Z",
    fill: "#444242",
    stroke: "#444242",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfissionais);
export default __webpack_public_path__ + "static/media/Profissionais.d2cc2a4eef43d26c50e092978c22b028.svg";
export { ForwardRef as ReactComponent };